<template>
  <div class="lots-filter">
    <snow-select
      v-model="form.status"
      label="Status"
      class="mb-7"
      :options="[
        { id: '', name: 'Todos' },
        { id: 'enabled', name: 'Ativo' },
        { id: 'canceled', name: 'Inativo' }
      ]"
    />
    <div class="snow-submit-buttons">
      <snow-button
        text="Aplicar"
        size="lg"
        class="order-lg-1 order-0"
        @click="apply"
      />
      <snow-button
        text="Cancelar"
        size="lg"
        variant="gray"
        @click="$emit('close')"
      />
    </div>
  </div>
</template>

<script>
import { formFields } from "@/functions/helpers";
export default {
  props: {
    value: {
      type: Object
    }
  },
  data() {
    return {
      ...formFields(["status"], this.value)
    };
  },
  methods: {
    apply() {
      this.$emit("input", this.form);
      this.$emit("close");
    }
  }
};
</script>
